module.exports = __webpack_public_path__ + "media/images/logo/logo-45eb8e8d9b7f1e19d8a8412c9a90a999.png";